var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import { SnackbarContent, IconButton, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import lightBlue from '@material-ui/core/colors/lightBlue';
import amber from '@material-ui/core/colors/amber';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
var variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};
var styles = function styles(theme) {
  return {
    snackbar: {
      width: '100%',
      marginBottom: '2em',
      maxWidth: '100%;'
    },
    success: {
      backgroundColor: green[600]
    },
    error: {
      backgroundColor: theme.palette.error.dark
    },
    info: {
      backgroundColor: lightBlue[500]
    },
    warning: {
      backgroundColor: amber[700]
    },
    icon: {
      fontSize: 20,
      opacity: 0.9,
      marginRight: theme.spacing.unit
    },
    messageContainer: {
      width: '80%'
    },
    message: {
      display: 'flex',
      alignItems: 'center'
    },
    action: {
      paddingLeft: '0px'
    }
  };
};
export var Alert = function (_React$Component) {
  _inherits(Alert, _React$Component);
  function Alert() {
    _classCallCheck(this, Alert);
    return _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).apply(this, arguments));
  }
  _createClass(Alert, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        message = _props.message,
        type = _props.type,
        hideClose = _props.hideClose,
        handleClose = _props.handleClose,
        classes = _props.classes;
      var Icon = variantIcon[type];
      return /*#__PURE__*/React.createElement(SnackbarContent, {
        className: classNames(classes[type], classes.snackbar),
        classes: {
          message: classes.messageContainer,
          action: classes.action
        },
        'aria-describedby': 'client-snackbar',
        message: /*#__PURE__*/React.createElement('span', {
          id: 'client-snackbar',
          className: classes.message
        }, /*#__PURE__*/React.createElement(Icon, {
          className: classes.icon
        }), message),
        action: !hideClose && [/*#__PURE__*/React.createElement(IconButton, {
          key: 'close',
          'aria-label': 'Close',
          color: 'inherit',
          onClick: handleClose
        }, /*#__PURE__*/React.createElement(CloseIcon, null))]
      });
    }
  }]);
  return Alert;
}(React.Component);
export default withStyles(styles)(Alert);